import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useEfaxIntegrationDisableMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    () => {
      return http.post(HTTP_ENDPOINTS.efax.disable());
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.efax.status],
        });

        options?.onSuccess?.(...args);
      },
    },
  );
}
